<template>
  <div />
</template>

<script>
export default {
  name: 'LoadingMap'
}
</script>
